import { render, staticRenderFns } from "./GrowthServices.vue?vue&type=template&id=85913612&scoped=true&"
import script from "./GrowthServices.vue?vue&type=script&lang=js&"
export * from "./GrowthServices.vue?vue&type=script&lang=js&"
import style0 from "./GrowthServices.vue?vue&type=style&index=0&id=85913612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85913612",
  null
  
)

export default component.exports